import { Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { ConfigurationMethodKind } from '../../../modules/projects/components/project-edit-step-2a-form/project-edit-step-2a-form.component';

@Component({
  selector: 'app-configuration-method-summary',
  standalone: true,
  imports: [RouterLink, NzIconModule, NzTypographyModule],
  templateUrl: './configuration-method-summary.component.html',
  styleUrl: './configuration-method-summary.component.scss',
})
export class ConfigurationMethodSummaryComponent {
  readonly label = input<string>('Configuration method');
  readonly configurationMethodKind = input.required<ConfigurationMethodKind>();

  // Derived label based on the selected configuration method
  protected readonly methodLabel = computed(() =>
    this.configurationMethodKind() === 'sizing'
      ? 'Sizing tool'
      : 'Manual entry',
  );
}
